import styled from "@emotion/styled";
import Typography, { TypographyOwnProps } from "@mui/material/Typography";
import { MDTypographyRootProps } from "../useInterfaces/MDTypographyRootInterfaces";

const MDTypographyRoot = styled(Typography)<MDTypographyRootProps>(({ theme, ownerState }) => {
    const palette = theme?.palette;
    const functions = theme?.functions;
    const typography = theme?.typography;
    const { color="dark", textTransform="none", verticalAlign="unset", fontWeight="medium" , opacity=1, 
      textGradient=false, darkMode=false,marginTop=0,marginLeft=0, marginRight=0,marginBottom=0} = ownerState || {};
    const { gradients, transparent, white } = palette;
    const { fontWeightLight, fontWeightRegular, fontWeightMedium, fontWeightBold } = typography;
    const { linearGradient } = functions;
    const mtValue: string = `${marginTop * 2}px`;
    const mlValue: string = `${marginLeft * 2}px`;
    const mrValue: string = `${marginRight * 2}px`;
    const mbValue: string = `${marginBottom * 2}px`;
    // fontWeight styles
    const fontWeights = {
      light: fontWeightLight,
      regular: fontWeightRegular,
      medium: fontWeightMedium,
      bold: fontWeightBold,
    };

    // styles for the typography with textGradient={true}
    const gradientStyles = () => ({
      backgroundImage:
        color !== "inherit" && color !== "text" && color !== "white" && gradients[color]
          ? linearGradient(gradients[color].main, gradients[color].state)
          : linearGradient(gradients.dark.main, gradients.dark.state),
      display: "inline-block",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: transparent.main,
      position: "relative",
      zIndex: 1,
    });

    // color value
    let colorValue = color === "inherit" || !palette[color] ? "inherit" : palette[color].main;

    if (darkMode && (color === "inherit" || !palette[color])) {
      colorValue = "inherit";
    } else if (darkMode && color === "dark") colorValue = white.main;
    return {
      opacity,
      textTransform,
      verticalAlign,
      textDecoration: "none",
      color: colorValue,
      fontWeight: fontWeights[fontWeight] || undefined,
      marginTop:mtValue,
      marginLeft:mlValue,
      marginRight:mrValue,
      marginBottom:mbValue,
      
     // ...(textGradient ? gradientStyles() : {}), 
    };
  }
);

export default MDTypographyRoot;
